import { Component, input, model } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { IconPriceDiscountComponent, IconShippingComponent } from '@pedix-workspace/angular-ui-icons';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { DeliveryType, EstablishmentCheckout } from '@pedix-workspace/utils';
import {
  ShippingCostResponseDelivery,
  hasDeliveryCost,
  hasMinimumPurchaseForFreeShipping,
  hasDeliveryCostToBeDefined,
  hasFreeShippingGrantedAmount,
  hasMinimumPurchaseErrorAmount,
  hasShippingEstimateBlockOrder,
  hasShippingEstimateError,
  hasOutOfDeliveryZone,
  getShippingErrorTranslationKey,
} from '@pedix-workspace/shared-delivery';
import { ShippingNotAllowedComponent } from '../shipping-not-allowed/shipping-not-allowed.component';
import { ShippingContinueWithConfirmationComponent } from '../shipping-continue-with-confirmation/shipping-continue-with-confirmation.component';

@Component({
  selector: 'pxw-shipping-cost-response-delivery',
  templateUrl: './shipping-cost-response-delivery.component.html',
  styleUrls: ['./shipping-cost-response-delivery.component.scss'],
  imports: [
    TranslocoDirective,
    AlertComponent,
    FormsModule,
    CurrencyFormatPipe,
    IconPriceDiscountComponent,
    IconShippingComponent,
    ShippingNotAllowedComponent,
    ShippingContinueWithConfirmationComponent,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ShippingCostResponseDeliveryComponent {
  readonly shippingCostResponse = input.required<ShippingCostResponseDelivery>();
  readonly isFormSubmitted = input.required<boolean>();
  readonly checkoutData = input<EstablishmentCheckout | null>(null);

  readonly outOfDeliveryZoneConfirmed = model.required<boolean>();

  protected readonly deliveryTypes = DeliveryType;

  protected readonly hasDeliveryCost = hasDeliveryCost;
  protected readonly hasMinimumPurchaseForFreeShipping = hasMinimumPurchaseForFreeShipping;
  protected readonly hasDeliveryCostToBeDefined = hasDeliveryCostToBeDefined;
  protected readonly hasFreeShippingGrantedAmount = hasFreeShippingGrantedAmount;
  protected readonly hasMinimumPurchaseErrorAmount = hasMinimumPurchaseErrorAmount;
  protected readonly hasShippingEstimateBlockOrder = hasShippingEstimateBlockOrder;
  protected readonly hasShippingEstimateError = hasShippingEstimateError;
  protected readonly hasOutOfDeliveryZone = hasOutOfDeliveryZone;
  protected readonly getShippingErrorTranslationKey = getShippingErrorTranslationKey;
}

